
const avatarCollectionKeys = {
    uuid: 'uuid',
    collectionName: 'collection_name',
    isPublished: 'is_published',
    createdAt: 'created_at',
    updatedOn: 'updated_on',
    planLevel: 'plan_level',
    darkCardTheme: 'dark_card_theme',
    isLogoDisabled: 'is_logo_disabled',
    avatarList: 'avatar_list',
    visitCount: 'visit_count',
    subtitleText: 'subtitle_text',
    subtitlePosition: 'subtitle_position',
    embedAlignPosition:'embed_align_position',
    imageSize: 'image_size',
  };


  const socialProofAvatarKeys = {
    uuid: 'uuid',
    wallUuid: 'wall_uuid',
    authorLink: 'author_link',
    authorImage: 'author_image',
    authorTagline: 'author_tagline',
    authorImageUrl: 'author_image_url',
    isAuthorImageInline: 'is_author_image_inline',
    createdAt: 'created_at',
  };

  exports.socialProofAvatarKeys = socialProofAvatarKeys;
  exports.avatarCollectionKeys = avatarCollectionKeys;